export enum DragEventType {
	PAGELIST = "pageList"
}

export interface PortalDragEvent {
	type: DragEventType;
	data: any;
}